export const isValidSearch = (query: string) => {
  // Input value such as true / false are parsed as boolean values
  if (typeof query === 'string') {
    return query.trim().length > 2;
  }
  return true;
};
